import React from 'react'

import { ZariContext } from '_zari/context'
import { Portlet } from '_zari/core'

import { CodigosTransaccionesConstant } from 'constants/index'

import { IdGen } from 'utils'

import * as PromocionesService from 'services/promocion.service'

import * as Forms from './forms'

const NuevoActualizarPage = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [__keyMainForm, setKeyMainForm] = React.useState(null)

  const editarDataRef = React.useRef({})

  const portletBreadcrumbs = React.useMemo(() => {
    if (match.params.id) {
      return [{ name: 'Promociones', path: `/${CodigosTransaccionesConstant.PROMOCIONES_LISTA}` }, { name: 'Editar' }]
    }
    return [{ name: 'Promociones', path: `/${CodigosTransaccionesConstant.PROMOCIONES_LISTA}` }, { name: 'Nuevo' }]
  }, [match.params.id])

  React.useEffect(() => {
    if (match.params.id) {
      PromocionesService.obtenerxIdAsEdicion(match.params.id)
        .then(({ data }) => {
          editarDataRef.current = data
          setKeyMainForm(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    } else {
      setKeyMainForm(IdGen.newId())
    }
  }, [match.params, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Promociones' breadcrumbs={portletBreadcrumbs} />
      <Portlet.Body>
        {__keyMainForm && <Forms.MainForm key={__keyMainForm} editarData={editarDataRef.current} />}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(NuevoActualizarPage)
